import ko from "knockout";
import componentCache from "flow/utils/componentCache";
import config from "flow/config";
import ajaxErrorHelper from "flow/ajax/ajaxErrorHelper";
import Component from "flow/Component";
import { Dictionary } from "flow/api/types";
import MyFlow from "flow/MyFlow";

export class Menu {
    isVisible = ko.observable<boolean>(false);
    isBroken = ko.observable<boolean>(false);
    title = ko.observable<string>();
    currentComponent = ko.observable<Component>(null);
    /** @deprecated */
    component = this.currentComponent;

    isMenuDetailsVisible = ko.observable<boolean>(false);

    currentId = ko.pureComputed<string>(() => {
        if (this.currentComponent()) {
            return this.currentComponent().manifest.id;
        }
        return "";
    });

    isLoading = ko.pureComputed<boolean>(() => {
        return this.currentComponent() !== null ? this.currentComponent().isLoading() : true;
    });

    init(myFlow: MyFlow) {
        myFlow.subscribe(config.topics.workingContextChangeStarted, (contextId: string) => {
            if (this.currentComponent() === null) return;

            const comp = this.currentComponent();

            if (!comp.manifest.toolbarItem) return;
            if (comp.manifest.toolbarItem.contextIds.length === 0) return;
            if (comp.manifest.toolbarItem.contextIds.includes(contextId)) return;

            this.onHide();
        });

        myFlow.subscribe(config.topics.componentAddedMobileMode, () => {
            this.isVisible(false);
        });

        myFlow.subscribe(config.topics.hideMenu, () => {
            this.isVisible(false);
        });
    }

    getMyFlow() {
        return this.currentComponent() !== null ? this.currentComponent().myFlow : undefined;
    }

    canLeave() {
        if (this.currentComponent() !== null) {
            const canLeaveResult = this.currentComponent().canLeave();

            if (canLeaveResult) {
                return [{ component: this.currentComponent(), result: canLeaveResult }];
            }
        }

        return [];
    }

    loadComponentById(id: string, viewContext: Dictionary, noOriginalViewContext?: boolean) {
        if (
            this.currentComponent() &&
            this.currentComponent().manifest.id === id &&
            this.isVisible() === true &&
            noOriginalViewContext
        ) {
            this.isVisible(false);
            this.currentComponent().onHide();

            return;
        }

        const component = componentCache.getComponentById(id);

        this.title(component.manifest.name);

        if (this.currentComponent()) {
            this.currentComponent().onHide();

            if (this.currentComponent().manifest.reuseInstance === false) {
                this.currentComponent().onDestroy();
            }

            this.currentComponent(null);
        }

        const focusDelay = this.isVisible() ? 0 : 500; // Whether to wait for css animation delay or not.

        this.isVisible(true);
        this.isBroken(false);

        this.currentComponent(component);

        component
            .load()
            .done(() => {
                component.activate(viewContext);
                component.onShow();

                // Workaround needed since css animation will prevent focus from working correctly the 2nd time. :(
                setTimeout(() => {
                    component.onFocus();
                }, focusDelay);
            })
            .fail(possibleJqXhr => {
                this.isBroken(true);
                this.isVisible(false);
                if (ajaxErrorHelper.isjqXhrObject(possibleJqXhr)) {
                    if (ajaxErrorHelper.isConnectionProblem(possibleJqXhr)) {
                        component.myFlow.handleAjaxError(possibleJqXhr);
                    }
                }
            });
    }

    onHide() {
        if (this.currentComponent()) {
            this.currentComponent().myFlow.clearLocalNotification();
        }
        this.isVisible(false);
    }

    onShowMenuDetail() {
        if (this.isMenuDetailsVisible()) this.isMenuDetailsVisible(false);
        else this.isMenuDetailsVisible(true);
    }
}

const menu = new Menu();
export default menu;
